module.exports = new __parcel__URL__("saxo_select.0711fd6c.mp3").toString();